<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.dailyReportList.push"
    :query-list="queryList"
    :is-show-store-select="isAdministrator"
    :is-store-select-clearable="true"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-last-thirty-day="true"
    :picker-options="pickerOptions"
    :show-summary="true"
    row-key="id"
    :expand-row-keys="expandedRowKeys"
  >
    <el-table-column type="expand">
      <template v-slot="{ row }">
        <div class="report-expand">
          <section class="expand-section">
            <h4>收入构成</h4>
            <div class="expand-grid">
              <div class="expand-item">
                <span>新生收入</span>
                <b class="danger-color">{{ row.new_income | toYuan }} 元（{{ row.new_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>老生收入</span>
                <b class="danger-color">{{ row.old_income | toYuan }} 元（{{ row.old_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>试课收入</span>
                <b class="danger-color">{{ row.trial_income | toYuan }} 元（{{ row.trial_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>修改课卡收入</span>
                <b class="danger-color">{{ row.update_income | toYuan }} 元（{{ row.update_income_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>其他收入</span>
                <b class="danger-color">{{ row.other_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>课次券收入</span>
                <b class="danger-color">{{ row.card_ticket_income | toYuan }} 元（{{ row.card_ticket_income_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>代金券收入</span>
                <b class="danger-color">{{ row.voucher_income | toYuan }} 元（{{ row.voucher_income_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>小程序预约收入</span>
                <b class="danger-color">{{ row.reservation_income | toYuan }} 元（{{ row.reservation_income_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>总收入</span>
                <b class="danger-color">{{ row.all_income | toYuan }} 元</b>
              </div>
            </div>
          </section>

          <section class="expand-section">
            <h4>支出 / 退款</h4>
            <div class="expand-grid">
              <div class="expand-item">
                <span>退卡支出</span>
                <b class="success-color">{{ row.refund_pay | toYuan }} 元（{{ row.refund_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>券退款支出</span>
                <b class="success-color">{{ row.ticket_refund_pay | toYuan }} 元（{{ row.ticket_refund_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>小程序预约退款</span>
                <b class="success-color">{{ row.reservation_pay | toYuan }} 元（{{ row.reservation_pay_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>退款支出合计</span>
                <b class="success-color">{{ row.refund_total | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>修改课卡支出</span>
                <b class="success-color">{{ row.update_pay | toYuan }} 元（{{ row.update_pay_count }} 笔）</b>
              </div>
              <div class="expand-item">
                <span>新增备用金</span>
                <b class="income-color">{{ row.reserve_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>备用金支出</span>
                <b class="success-color">{{ row.expenditure | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>备用金期末</span>
                <b>{{ (row.reserve_balance === null || row.reserve_balance === undefined ? row.initial_cash - row.expenditure : row.reserve_balance) | toYuan }} 元</b>
              </div>
            </div>
          </section>

          <section class="expand-section">
            <h4>收款方式</h4>
            <div class="expand-grid">
              <div class="expand-item">
                <span>门店微信账号</span>
                <b class="danger-color">{{ row.we_chat_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>门店支付宝账号</span>
                <b class="danger-color">{{ row.alipay_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>门店富掌柜账号</span>
                <b class="danger-color">{{ row.fu_zhang_gui_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>门店美团账号</span>
                <b class="danger-color">{{ row.meituan_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>门店银行账号</span>
                <b class="danger-color">{{ row.card_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>现金收入</span>
                <b class="danger-color">{{ row.cash_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>总部有赞账号</span>
                <b class="danger-color">{{ row.you_zan_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>总部抖音账号</span>
                <b class="danger-color">{{ row.dou_yin_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>总部银行账号</span>
                <b class="danger-color">{{ row.transfer_income | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>总部小程序账号</span>
                <b class="danger-color">{{ row.applet_income | toYuan }} 元</b>
              </div>
            </div>
          </section>

          <section class="expand-section">
            <h4>课消 / 课时</h4>
            <div class="expand-grid">
              <div class="expand-item">
                <span>产生课消</span>
                <b>{{ row.course_consumption | toYuan }} 元</b>
              </div>
              <div v-if="isAdministrator" class="expand-item">
                <span>净利润课消</span>
                <b>{{ row.profit_consumption | toYuan }} 元</b>
              </div>
              <div class="expand-item">
                <span>课时总人次</span>
                <b>{{ row.total_attendance | toYuan }} 人</b>
              </div>
              <div class="expand-item">
                <span>总课时数</span>
                <b>{{ row.group_course_count | toYuan }} 小时</b>
              </div>
              <div class="expand-item">
                <span>每课时平均人数</span>
                <b>{{ row.average_attendance | toYuan }} 人</b>
              </div>
            </div>
          </section>

          <section class="expand-section">
            <h4>填报信息</h4>
            <div class="expand-grid">
              <div class="expand-item">
                <span>填报人</span>
                <b>{{ row.administrator_nickname || '-' }}</b>
              </div>
              <div class="expand-item">
                <span>添加时间</span>
                <b>{{ row.add_time | timeToYmdHi }}</b>
              </div>
              <div class="expand-item">
                <span>最后保存</span>
                <b>{{ row.save_time | timeToYmdHi }}</b>
              </div>
            </div>
          </section>
        </div>
      </template>
    </el-table-column>

    <v-column-time field="report_date" time-format="timeToYmd" value="日期"/>

    <el-table-column v-if="isAdministrator" label="所属门店" prop="store_name" width="130"/>

    <el-table-column label="新生收入" prop="new_income" type="money" width="100">
      <template v-slot="{ row }">
        <span class="danger-color">{{ row.new_income | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="老生收入" prop="old_income" type="money" width="100">
      <template v-slot="{ row }">
        <span class="danger-color">{{ row.old_income | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column
      label="总收入"
      sortable="custom"
      :sort-orders="['ascending', 'descending']"
      :prop="orderByColumns.allIncome"
      type="money"
      width="120"
    >
      <template v-slot="{ row }">
        <span class="danger-color bolder">{{ row.all_income | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="退款支出" prop="refund_total" type="money" width="120">
      <template v-slot="{ row }">
        <span class="color-pay">{{ row.refund_total | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="新增备用金" prop="reserve_income" type="money" width="110">
      <template v-slot="{ row }">
        <span class="income-color">{{ row.reserve_income | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="备用金支出" prop="expenditure" type="money" width="110">
      <template v-slot="{ row }">
        <span class="color-pay">{{ row.expenditure | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="备用金期末" prop="reserve_balance" type="money" width="110">
      <template v-slot="{ row }">
        <span>{{ (row.reserve_balance === null || row.reserve_balance === undefined ? row.initial_cash - row.expenditure : row.reserve_balance) | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="产生课消" prop="course_consumption" type="money" width="110">
      <template v-slot="{ row }">
        <span>{{ row.course_consumption | toYuan }}</span>
      </template>
    </el-table-column>

    <el-table-column label="最后保存" prop="save_time" width="150" type="isNotSummary">
      <template v-slot="{ row }">
        <span>{{ row.save_time | timeToYmdHi }}</span>
      </template>
    </el-table-column>
    <div slot="append" class="table-count-bar">
      合计收入：门店微信账号 <span class="table-money">{{ weChatIncome | toYuan }}</span> 元，
      门店支付宝账号 <span class="table-money">{{ alipayIncome | toYuan }}</span> 元，
      门店富掌柜账号 <span class="table-money">{{ fuZhangGuiIncome | toYuan }}</span> 元，
      门店美团账号 <span class="table-money">{{ meituanIncome | toYuan }}</span> 元，
      门店银行账号 <span class="table-money">{{ cardIncome | toYuan }}</span> 元，
      现金 <span class="table-money">{{ cashIncome | toYuan }}</span> 元，
      总部有赞账号 <span class="table-money">{{ youZanIncome | toYuan }}</span> 元，
      总部抖音账号 <span class="table-money">{{ douYinIncome | toYuan }}</span> 元，
      总部银行账号 <span class="table-money">{{ transferIncome | toYuan }}</span> 元，
      总部小程序账号 <span class="table-money">{{ appletIncome | toYuan }}</span> 元。
    </div>

    <el-table-column label="操作" width="250px">
      <template v-slot="{ row }">
        <v-list-button name="查看" icon="browse" :to="RouteConfig.dailyReportDetail.to(row.id)"/>

        <v-list-button :to="RouteConfig.dailyReportEdit.to(row.id)"/>

        <v-popover>
          <v-popover-item
            icon="bin"
            name="删除总结"
            @click="handleDelete(row)"
            :is-loading="isDeleting[row.id]"
            message="确认要删除该日总结吗？"
          />
        </v-popover>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>日期</span>
              <span>{{ v.report_date | timeToYmd }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div v-if="isAdministrator" class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_name || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>新生收入</span>
              <span>{{ v.new_income | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>老生收入</span>
              <span>{{ v.old_income | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>试课收入</span>
              <span>{{ v.trial_income | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改课卡补差价收入</span>
              <span>{{ v.update_income | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>其他收入</span>
              <span>{{ v.other_income | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>总收入</span>
              <span>{{ v.all_income | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>退款支出</span>
              <span>{{ v.refund_total | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>新增备用金</span>
              <span>{{ v.reserve_income | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>备用金支出</span>
              <span>{{ v.expenditure | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>现金收入</span>
              <span>{{ v.cash_income | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>刷卡收入</span>
              <span>{{ v.card_income | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>有赞收入</span>
              <span>{{ v.you_zan_income | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>抖音收入</span>
              <span>{{ v.dou_yin_income | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>对公转账收入</span>
              <span>{{ v.dou_yin_income | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>备用金期末</span>
              <span>{{ (v.reserve_balance === null || v.reserve_balance === undefined ? v.initial_cash - v.expenditure : v.reserve_balance) | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>产生课消</span>
              <span>{{ v.course_consumption | toYuan }} 元</span>
            </div>

            <div v-if="isAdministrator" class="list-item-detail">
              <span>净利润课消</span>
              <span>{{ v.profit_consumption | toYuan }} 元</span>
            </div>

            <div class="list-item-detail">
              <span>课时总人次</span>
              <span>{{ v.total_attendance | toYuan }} 人</span>
            </div>

            <div class="list-item-detail">
              <span>大课总课时数</span>
              <span>{{ v.group_course_count | toYuan }} 小时</span>
            </div>

            <div class="list-item-detail">
              <span>每课时平均人数</span>
              <span>{{ v.average_attendance | toYuan }} 人</span>
            </div>

            <div class="list-item-button">
              <v-list-button name="查看" icon="browse" :to="RouteConfig.dailyReportDetail.to(v.id)"/>

              <v-list-button :to="RouteConfig.dailyReportEdit.to(v.id)"/>

              <v-popover>
                <v-popover-item
                  icon="bin"
                  name="删除总结"
                  @click="handleDelete(v)"
                  :is-loading="isDeleting[v.id]"
                  message="确认要删除该日总结吗？"
                />
              </v-popover>
            </div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <strong>本页合计</strong>
            </div>
            <div class="list-item-detail">
              <span>新生收入</span>
              <span class="income-count">{{ newIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>老生收入</span>
              <span class="income-count">{{ oldIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>试课收入</span>
              <span class="income-count">{{ trialIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>修改课卡收入</span>
              <span class="income-count">{{ updateIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>其他收入</span>
              <span class="income-count">{{ otherIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>总收入</span>
              <span class="income-count">{{ allIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>退款支出</span>
              <span class="pay-count">{{ refundPay | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>修改课卡支出</span>
              <span class="pay-count">{{ updatePay | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>现金支出</span>
              <span class="pay-count">{{ expenditure | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>产生课消</span>
              <span class="income-count">{{ courseConsumption | toYuan }} 元</span>
            </div>
            <div v-if="isAdministrator" class="list-item-detail">
              <span>净利润课消</span>
              <span :class="profitConsumption >= 0 ? 'income-count' : 'pay-count'">{{ profitConsumption | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <strong>收入构成</strong>
            </div>
            <div class="list-item-detail">
              <span>门店微信账号</span>
              <span class="income-count">{{ weChatIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>门店支付宝账号</span>
              <span class="income-count">{{ alipayIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>门店富掌柜账号</span>
              <span class="income-count">{{ fuZhangGuiIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>门店美团账号</span>
              <span class="income-count">{{ meituanIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>门店银行账号</span>
              <span class="income-count">{{ cardIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>现金</span>
              <span class="income-count">{{ cashIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>总部有赞账号</span>
              <span class="income-count">{{ youZanIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>总部抖音账号</span>
              <span class="income-count">{{ douYinIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>总部银行账号</span>
              <span class="income-count">{{ transferIncome | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>总部小程序账号</span>
              <span class="income-count">{{ appletIncome | toYuan }} 元</span>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index, destroy } from '@/api/daily-report';
import { checkYmdIsBetweenSetUpAndToday } from '@/utils/validate';
import { getLegalQueryList } from '@/utils/formats';
import { plus } from "@/filters";

const orderByColumns = {
  addTime: 'add_time',
  allIncome: 'all_income',
};

export default {
  name: RouteConfig.dailyReportList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isDeleting: {},
    count: 0,
    list: [],
    expandedRowKeys: [],
    reports: [],
    stores: [],
    timeLimit: [],

    weChatIncome: 0,
    alipayIncome: 0,
    fuZhangGuiIncome: 0,
    meituanIncome: 0,
    cardIncome: 0,
    cashIncome: 0,
    youZanIncome: 0,
    douYinIncome: 0,
    transferIncome: 0,
    appletIncome: 0,

    newIncome: 0,
    oldIncome: 0,
    trialIncome: 0,
    updateIncome: 0,
    otherIncome: 0,
    allIncome: 0,
    refundPay: 0,
    updatePay: 0,
    expenditure: 0,
    courseConsumption: 0,
    profitConsumption: 0,

    orderByColumns,
    queryList: {
      store_id: '',
      start_date: '',
      end_date: '',
      order_by: orderByColumns.addTime,
      is_asc: 0,
      page: 1,
      size: 10,
    },
    pickerOptions: {
      disabledDate(time) {
        return time.getTime() >= Date.now();
      },
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'isManager',
      'isReceptionist',
      'userStoreId',
    ]),
  },
  methods: {
    refresh() {
      RouteConfig.dailyReportList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleTimeLimitChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [start_date, end_date] = times;

      Object.assign(this.queryList, {
        start_date,
        end_date,
        page: 1,
      });
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;
      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
      const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      } else {
        // const today = getDay();
        queryList.start_date = '';
        queryList.end_date = '';
      }

      this.isLoading = true;
      const { isError, data } = await index(this.queryList);
      this.isLoading = false;

      if (isError) {
        if (next) next();
        return;
      }

      this.count = data.count;
      const list = data.list.map(item => ({
        ...item,
        refund_total: plus(
          item.refund_pay || 0,
          item.ticket_refund_pay || 0,
          item.reservation_pay || 0,
        ),
        save_time: Number(item.update_time) || Number(item.add_time),
      }));
      this.list = list;

      // 保存成功后返回列表时，自动展开刚保存的那一行，方便直接核对完整统计
      const expandId = Number(sessionStorage.getItem('daily_report_expand_id'));
      if (expandId) sessionStorage.removeItem('daily_report_expand_id');
      this.expandedRowKeys = [];
      const expandRow = expandId && list.find(v => Number(v.id) === expandId);
      if (expandRow) {
        // 等表格拿到新数据后再展开，避免 expand-row-keys 先于行数据生效；
        // 用行自身的 id，兼容接口返回数字/字符串两种类型
        this.$nextTick(() => {
          this.expandedRowKeys = [expandRow.id];
        });
      }

      const length = list.length;

      let weChatIncome = 0;
      let alipayIncome = 0;
      let fuZhangGuiIncome = 0;
      let meituanIncome = 0;
      let cardIncome = 0;
      let cashIncome = 0;
      let youZanIncome = 0;
      let douYinIncome = 0;
      let transferIncome = 0;
      let appletIncome = 0;

      let newIncome = 0;
      let oldIncome = 0;
      let trialIncome = 0;
      let updateIncome = 0;
      let otherIncome = 0;
      let allIncome = 0;
      let refundPay = 0;
      let updatePay = 0;
      let expenditure = 0;
      let courseConsumption = 0;
      let profitConsumption = 0;

      for (let i = 0;i < length;i++) {
        weChatIncome = plus(weChatIncome, list[i].we_chat_income);
        alipayIncome = plus(alipayIncome, list[i].alipay_income);
        fuZhangGuiIncome = plus(fuZhangGuiIncome, list[i].fu_zhang_gui_income);
        meituanIncome = plus(meituanIncome, list[i].meituan_income);
        cardIncome = plus(cardIncome, list[i].card_income);
        cashIncome = plus(cashIncome, list[i].cash_income);
        youZanIncome = plus(youZanIncome, list[i].you_zan_income);
        douYinIncome = plus(douYinIncome, list[i].dou_yin_income);
        transferIncome = plus(transferIncome, list[i].transfer_income);
        appletIncome = plus(appletIncome, list[i].applet_income);

        newIncome = plus(newIncome, list[i].new_income);
        oldIncome = plus(oldIncome, list[i].old_income);
        trialIncome = plus(trialIncome, list[i].trial_income);
        updateIncome = plus(updateIncome, list[i].update_income);
        otherIncome = plus(otherIncome, list[i].other_income);
        allIncome = plus(allIncome, list[i].all_income);
        refundPay = plus(refundPay, list[i].refund_total);
        updatePay = plus(updatePay, list[i].update_pay);
        expenditure = plus(expenditure, list[i].expenditure);
        courseConsumption = plus(courseConsumption, list[i].course_consumption);
        profitConsumption = plus(profitConsumption, list[i].profit_consumption);
      }
      Object.assign(this, {
        weChatIncome,
        alipayIncome,
        fuZhangGuiIncome,
        meituanIncome,
        cardIncome,
        cashIncome,
        youZanIncome,
        douYinIncome,
        transferIncome,
        appletIncome,
        newIncome,
        oldIncome,
        trialIncome,
        updateIncome,
        otherIncome,
        allIncome,
        refundPay,
        updatePay,
        expenditure,
        courseConsumption,
        profitConsumption,
      });
      if (next) next();
    },
    async handleDelete({ id }) {
      this.$set(this.isDeleting, id, true);
      const { isError } = await destroy(id);
      this.$set(this.isDeleting, id, false);
      if (!isError) this.load();
    },
  },
  beforeMount() {
    this.load();
  },
};
</script>

<style scoped>
.report-expand {
    padding: 4px 20px 12px;
}

.expand-section + .expand-section {
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px dashed #ebeef5;
}

.expand-section h4 {
    margin: 0 0 10px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
}

.expand-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 8px 24px;
}

.expand-item {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    font-size: 13px;
    line-height: 22px;
}

.expand-item > span {
    color: #606266;
}

.expand-item > b {
    font-weight: 600;
}

@media (max-width: 767px) {
    .report-expand {
        padding: 4px 12px 12px;
    }

    .expand-grid {
        grid-template-columns: 1fr;
    }
}
</style>
